import Button from '@propertypal/web-ui/src/buttons/Button';
import TextInput from '@propertypal/web-ui/src/inputs/TextInput';
import { Icon, Input } from '@propertypal/web-ui/src/inputs/TextInput.style';
import styled, { css } from 'styled-components';

export const Alert = styled.div`
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid ${({ theme }) => theme.lightGrey};
  padding: 16px;
  font-weight: 600;
  display: flex;
  width: 100%;
  text-align: left;
  gap: 8px;
  margin-bottom: 16px;
`;

export const AlertMessageContainer = styled.div`
  flex: 1 1 auto;
`;

export const AlertMessage = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SearchInput = styled(TextInput)`
  ${Input} {
    padding: 0 15px 0 40px;
  }
  ${Icon} {
    left: -10px;
    svg {
      color: ${({ theme }) => theme.textDark};
    }
  }
`;

export const MapContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  height: 400px;
`;

export const Form = styled.form<{ $isSubmitting: boolean }>`
  margin-top: 16px;

  ${({ $isSubmitting }) =>
    $isSubmitting
      ? css`
          pointer-events: none;
          opacity: 0.5;
        `
      : ''}
`;

export const InputContainer = styled.div`
  margin-bottom: 16px;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
`;
